import PropTypes from 'prop-types';

const CheckedCircleIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.992 6.0636C28.1242 4.34019 23.8028 3.91325 19.6725 4.84644C15.5422 5.77963 11.8242 8.02296 9.07299 11.2419C6.32179 14.4608 4.68482 18.4827 4.4062 22.708C4.12759 26.9333 5.22227 31.1354 7.52698 34.6877C9.83169 38.2399 13.2229 40.952 17.195 42.4195C21.167 43.887 25.507 44.0311 29.5676 42.8305C33.6283 41.6299 37.192 39.1489 39.7274 35.7574C42.2628 32.3659 43.6339 28.2457 43.6364 24.0112V22.0052C43.6364 20.8002 44.6132 19.8234 45.8182 19.8234C47.0232 19.8234 48 20.8002 48 22.0052V24.0125C47.997 29.1879 46.3212 34.2249 43.2224 38.3701C40.1236 42.5153 35.7679 45.5477 30.8048 47.0151C25.8418 48.4825 20.5374 48.3063 15.6827 46.5127C10.828 44.7192 6.68317 41.4044 3.8663 37.0627C1.04944 32.721 -0.288501 27.5851 0.0520243 22.4209C0.39255 17.2567 2.3933 12.3409 5.75587 8.40671C9.11844 4.4725 13.6627 1.73065 18.7108 0.590087C23.759 -0.550479 29.0406 -0.0286543 33.768 2.07774C34.8687 2.56817 35.3634 3.858 34.8729 4.95867C34.3825 6.05934 33.0927 6.55403 31.992 6.0636Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.3602 5.01439C48.2127 5.86602 48.2134 7.24747 47.3617 8.09995L25.5436 29.9399C25.1345 30.3495 24.5794 30.5796 24.0006 30.5798C23.4217 30.5799 22.8665 30.35 22.4572 29.9407L15.9118 23.3953C15.0597 22.5432 15.0597 21.1618 15.9118 20.3097C16.7638 19.4577 18.1453 19.4577 18.9973 20.3097L23.9992 25.3116L44.2746 5.01594C45.1263 4.16346 46.5077 4.16277 47.3602 5.01439Z"
        fill={fill}
      />
    </svg>
  </div>
);

CheckedCircleIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CheckedCircleIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CheckedCircleIcon;
